module.exports = __webpack_public_path__ + "static/media/ny.262732e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Home/assets/ny.jpg
// module id = 2444
// module chunks = 0